var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16434",
    "data-name": "Group 16434",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.855,
    height: 18.845,
    viewBox: "0 0 18.855 18.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2018",
    "data-name": "Rectangle 2018",
    width: 18.855,
    height: 18.845,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16390",
    "data-name": "Group 16390",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16390-2",
    "data-name": "Group 16390",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5322",
    "data-name": "Path 5322",
    d: "M8.765,0h1.326c.3.04.607.071.907.124a9.206,9.206,0,0,1,5.282,2.831,9.243,9.243,0,0,1,2.488,7.767A8.669,8.669,0,0,1,17.033,15,9.254,9.254,0,0,1,8.12,18.764a8.736,8.736,0,0,1-4.261-1.727A9.3,9.3,0,0,1,.149,11.107c-.063-.336-.1-.677-.149-1.016V8.765c.028-.218.052-.436.085-.654A9.245,9.245,0,0,1,1.81,3.87,9.3,9.3,0,0,1,7.751.149C8.086.087,8.427.049,8.765,0m8.619,9.427A7.956,7.956,0,1,0,9.42,17.384a7.965,7.965,0,0,0,7.964-7.957",
    transform: "translate(0 0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5323",
    "data-name": "Path 5323",
    d: "M14.223,14.691q0,1.16,0,2.319a.737.737,0,1,1-1.472.005q0-2.328,0-4.657a.737.737,0,1,1,1.472-.005q0,1.169,0,2.338",
    transform: "translate(-4.058 -3.683)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5324",
    "data-name": "Path 5324",
    d: "M13.379,7.343a.983.983,0,0,1,.981,1.018.994.994,0,0,1-1.987-.044.983.983,0,0,1,1.006-.975",
    transform: "translate(-3.938 -2.337)",
    fill: "#1a1818"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.4192a6072ab022e6b38829ded3195d24.svg";
export { ForwardRef as ReactComponent };